import React from "react";
import SbEditable from "storyblok-react";
import styles from "./logo-strip.module.scss";
import type { LogoStripStoryblok } from "./types";

interface Props {
  blok: LogoStripStoryblok;
}

const LogoStrip = ({ blok }: Props) => {
  const logos = Array.isArray(blok.logos) ? blok.logos : [];

  return (
    // @ts-expect-error
    <SbEditable content={blok}>
      <div className={styles.logoStrip}>
        {blok.title ? (
          <p className={styles.logoStripTitle}>{blok.title}</p>
        ) : null}
        <div className={styles.logoStripTrack}>
          {logos.length
            ? logos.map((logo) => (
                <div key={logo._uid} className={styles.logoStripItem}>
                  {logo.image?.filename ? (
                    // eslint-disable-next-line @next/next/no-img-element -- contain-fit logos with variable dimensions; next/image adds no value here
                    <img
                      src={logo.image.filename}
                      alt={logo.alt || logo.image.alt || ""}
                      className={styles.logoStripImage}
                      loading="lazy"
                    />
                  ) : null}
                </div>
              ))
            : null}
        </div>
      </div>
    </SbEditable>
  );
};

export default LogoStrip;
